import {TypedValue} from 'notebook/tables/TableConstants';
import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import PreciseDecimal from 'util/precise-decimal/PreciseDecimal';

/** Convert TypedValues to PreciseDecimals
 *
 * Returns undefined if the typed value is empty or cannot be converted.
 */
export function typedValueToPreciseDecimal(typedValue: TypedValue | null): PreciseDecimal | undefined {
  if (typedValue == null) {
    return undefined;
  }
  return PreciseDecimal.ofOrUndefined(formatTypedValue(typedValue));
}

export function preciseDecimalToTypedValue(preciseDecimal: PreciseDecimal): TypedValue {
  return {
    type: FieldType.FLOAT,
    value: preciseDecimal.value,
    rawValue: preciseDecimal.value,
    floatValue: preciseDecimal.toFloat(),
  };
}
